import React from 'react';
import { IconFont } from '~/components';
import classNames from 'classnames';
import { map } from '@libs/shared';
import { isMobileUA } from '~/utils';

export interface SuiteSelectListProps {
    className?: string;
    title: string;
    description: string;
    items: {
        suiteId: number;
        name?: string;
        icon?: string;
        [key: string]: any;
    }[];
    onSelect?: (item: SuiteSelectListProps['items'][number]) => void;
}

/**
 * 列表形式的登录产品选择组件
 */
export const SuiteSelectList: React.FC<SuiteSelectListProps> = (props) => {
    const { className, title, description, items, onSelect } = props;

    return (
        <div
            className={classNames('fx-suite-select-list', className, {
                'is-mobile': isMobileUA()
            })}
        >
            <div className="suite-select-title">{title}</div>
            <div className="suite-select-desc">{description}</div>
            <div className="suite-select-list-content">
                {map(items, (item) => (
                    <div
                        className="suite-select-list-item"
                        key={item.suiteId}
                        onClick={() => onSelect?.(item)}
                    >
                        <img className="suite-select-list-icon" src={item.icon} alt="" />
                        <span className="suite-select-list-name" title={item.name}>
                            {item.name}
                        </span>
                        <IconFont className="suite-select-list-arrow" type="angle-right" />
                    </div>
                ))}
            </div>
        </div>
    );
};
